import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/store";
import { UpdateCampaignRequest } from "@/modules/stochastic/features/CampaignManagement/api/updateCampaign/types";
import { updateCampaign } from "@/modules/stochastic/features/CampaignManagement/api/updateCampaign/updateCampaignApi";

interface CampaignState {
  loadingUpdate: boolean;
  errorUpdate: string | null;
  selectedCampaignId: number | null;
}

const initialState: CampaignState = {
  loadingUpdate: false,
  errorUpdate: null,
  selectedCampaignId: null,
};

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setLoadingUpdate: (state, action: PayloadAction<boolean>) => {
      state.loadingUpdate = action.payload;
    },
    setErrorUpdate: (state, action: PayloadAction<string | null>) => {
      state.errorUpdate = action.payload;
    },
    setSelectedCampaignId: (state, action: PayloadAction<number | null>) => {
      state.selectedCampaignId = action.payload;
    },
  },
});

export const { setLoadingUpdate, setErrorUpdate, setSelectedCampaignId } =
  campaignSlice.actions;

export const updateCampaignAction =
  (
    campaignId: number,
    requestData: UpdateCampaignRequest,
    callback?: () => void,
  ): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoadingUpdate(true));
    dispatch(setErrorUpdate(null));
    try {
      await updateCampaign(campaignId, requestData);
      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch(
        setErrorUpdate(
          error instanceof Error ? error.message : "Failed to update campaign",
        ),
      );
    } finally {
      dispatch(setLoadingUpdate(false));
    }
  };

export default campaignSlice.reducer;
